import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LangContext";
import { Cookie, X } from "lucide-react";

const COPY = {
  fr: {
    title: "Témoins",
    body: "Nous utilisons uniquement des témoins essentiels au fonctionnement du site.",
    accept: "Accepter",
    essential: "Essentiels",
    learn: "En savoir plus",
  },
  en: {
    title: "Cookies",
    body: "We only use essential cookies to make the site work.",
    accept: "Accept",
    essential: "Essential",
    learn: "Learn more",
  },
  es: {
    title: "Cookies",
    body: "Solo usamos cookies esenciales para el funcionamiento del sitio.",
    accept: "Aceptar",
    essential: "Esenciales",
    learn: "Más info",
  },
  zh: {
    title: "Cookie",
    body: "我们仅使用网站运行所必需的Cookie。",
    accept: "接受",
    essential: "仅必要",
    learn: "了解更多",
  },
};

const CookieBanner = () => {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("cookie_consent");
    if (!stored) setVisible(true);
  }, []);

  const consent = (choice) => {
    localStorage.setItem("cookie_consent", JSON.stringify({ choice, ts: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;
  const c = COPY[lang] || COPY.fr;

  return (
    <div
      className="fixed z-[60] bottom-3 left-3 right-3 md:left-4 md:right-auto md:max-w-sm animate-in slide-in-from-bottom-4 fade-in"
      data-testid="cookie-banner"
    >
      <div className="rounded-xl bg-black/95 border border-slate-800 shadow-2xl backdrop-blur px-3 py-3 md:px-4 md:py-3.5">
        <div className="flex items-start gap-2.5">
          <div className="hidden sm:flex w-8 h-8 rounded-lg bg-blue-500/15 border border-blue-500/30 items-center justify-center flex-shrink-0">
            <Cookie className="w-4 h-4 text-blue-400" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2">
              <h3 className="font-semibold text-white text-sm">{c.title}</h3>
              <button onClick={() => consent("essential")} className="text-slate-500 hover:text-white -mt-0.5 -mr-0.5" data-testid="cookie-close" aria-label={{"fr":"Fermer","en":"Close","es":"Cerrar","zh":"关闭"}[lang]}>
                <X className="w-3.5 h-3.5" aria-hidden="true" />
              </button>
            </div>
            <p className="mt-1 text-xs text-slate-400 leading-snug">{c.body}</p>
            <div className="mt-2.5 flex flex-wrap items-center gap-1.5">
              <Button size="sm" onClick={() => consent("accept")} className="h-7 rounded-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-xs px-3" data-testid="cookie-accept">
                {c.accept}
              </Button>
              <Button size="sm" variant="outline" onClick={() => consent("essential")} className="h-7 rounded-full text-xs px-3" data-testid="cookie-essential">
                {c.essential}
              </Button>
              <Link to="/politique/temoins" className="text-xs text-slate-400 hover:text-blue-400 underline underline-offset-2 ml-1" data-testid="cookie-learn">
                {c.learn}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
